import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

const RATIO = 0.08;

export const IconFolder = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    // In this icon we use stroke instead of fill
    const currentStroke = isNumber(size) ? `${size * RATIO}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          d="M19.61 16.688C19.61 17.0755 19.4561 17.4471 19.1821 17.7211C18.9081 17.9951 18.5365 18.149 18.149 18.149H6.461C6.07352 18.149 5.70191 17.9951 5.42792 17.7211C5.15393 17.4471 5 17.0755 5 16.688V6.461C5 6.07352 5.15393 5.70191 5.42792 5.42792C5.70191 5.15393 6.07352 5 6.461 5H10.1135L11.5745 7.1915H18.149C18.5365 7.1915 18.9081 7.34543 19.1821 7.61942C19.4561 7.89341 19.61 8.26502 19.61 8.6525V16.688Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);
